/**
 * /app/trusts/$id/resolutions — Resolution list, trust-scoped (route shell).
 *
 * Screen impl in `./index-screen.tsx`, lazy-loaded via `lazyRouteComponent`.
 * This is a deep trust sub-tab (resolution list + create modal + bulk-delete +
 * search-all), not a first-paint route, so the body leaves the entry bundle
 * (200 kB gzip budget). Same shell+screen pattern as the sibling `../audit.tsx`
 * / `../documents.tsx` / `../loa-low.tsx` tabs. The committed routeTree.gen.ts
 * imports only `Route` from here, so the move needs no plugin regen (which would
 * rewrite the hand-edited custom URLs).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/resolutions/')({
  component: lazyRouteComponent(() => import('./index-screen'), 'ResolutionsScreen'),
});
